import React from 'react'

const Education = ({leftinfo}) => {
    
    return (
        <>
        {leftinfo.educations.map((education)=> {
            return(
                <div className='education-box'>
                    {education.head1 && <h1 className='place-title'>{education.head1}</h1>}
                    <div className="schooling">
                        {education.school1 && <h2 className='place-name'>{education.school1}</h2>}
                        {education.years1 && <p className='years'>{education.years1}</p>}
                        {education.schoolexp && <p className='experience'>{education.schoolexp}</p>}
                    </div>
                </div>
            )
        })}
        
    </>
  )
  
  
}

export default Education